import React from "react";

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const RequireAuth = ({ children }) => {
    const { accessToken, loading } = useAuth();

    if (loading) return <div>Загрузка...</div>;
    if (!accessToken) return <Navigate to="/login" replace />;

    return children;
};